var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChnagePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.316,
    height: 15.758,
    viewBox: "0 0 14.316 15.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chnage_password",
    transform: "translate(0.75 0.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33145",
    "data-name": "Path 33145",
    d: "M5.924,16.5h9.968a1.424,1.424,0,0,1,1.424,1.424v4.984a1.424,1.424,0,0,1-1.424,1.424H5.924A1.424,1.424,0,0,1,4.5,22.908V17.924A1.424,1.424,0,0,1,5.924,16.5Z",
    transform: "translate(-4.5 -10.088)",
    fill: "#fff",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33146",
    "data-name": "Path 33146",
    d: "M10.5,9.4V6.556a3.56,3.56,0,0,1,7.049-.712",
    transform: "translate(-7.652 -2.992)",
    fill: "none",
    stroke: "#dfdfdf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChnagePassword);
export default __webpack_public_path__ + "static/media/chnage_password.7d419c79347f339bc4c97fffdaddfbcc.svg";
export { ForwardRef as ReactComponent };